import { taskTypes } from '@views/task-batch/task-batch-opts'

export default {
  data () {
    return {
      taskTypeOpts: {
        51: '群组门店关联',
        52: '上传群组控制目标数',
        53: '批量上传群组控制目标数',
        54: '群组门店关联(冲突处理)',
        55: '开启关闭群组控制目标数',
        [taskTypes.BATCH_OPEN_TASK_GROUP_BY_SEARCH.value]: taskTypes.BATCH_OPEN_TASK_GROUP_BY_SEARCH.label,
        [taskTypes.BATCH_CLOSE_TASK_GROUP_BY_SEARCH.value]: taskTypes.BATCH_CLOSE_TASK_GROUP_BY_SEARCH.label,
      },
      batchJobFields: [
        {
          prop: 'id',
          label: '编号'
        },
        {
          prop: 'display_name',
          label: '名称'
        },
        {
          prop: 'admin_name',
          label: '创建人'
        },
        {
          prop: 'process',
          label: '任务进度',
          formatter: this.formatProcess
        },
        {
          prop: 'task_type',
          label: '类型',
          formatter: row => this.taskTypeOpts[row.task_type]
        },
        {
          prop: 'created_at',
          label: '上传时间'
        },
        {
          prop: 'status',
          label: '状态',
          formatter: this.formatStatus
        }
      ],
      marketUploadDemoHeader: [
        {
          key: 'market_id',
          text: '门店ID',
        },
        {
          key: 'market_name',
          text: '门店名称',
        },
        {
          key: 'group_name_1',
          text: '群组名称1',
        },
        {
          key: 'group_name_2',
          text: '群组名称2',
        },
        {
          key: 'group_name_3',
          text: '群组名称3',
        },
        {
          key: 'group_name_4',
          text: '群组名称4',
        },
        {
          key: 'group_name_5',
          text: '群组名称5',
        },
      ],
      importMarketGroupTargetNumHeader: [
        {
          key: 'group_name',
          text: '群组名称',
        },
        {
          key: 'target_num',
          text: '群组目标数',
        },
        {
          key: 'task_max_salary',
          text: '任务最大金额/元',
        },
      ],
      batchImportMarketGroupTargetNumHeader: [
        {
          key: 'group_name',
          text: '群组名称',
        },
        {
          key: 'target_num',
          text: '群组目标数',
        },
        {
          key: 'task_max_salary',
          text: '任务最大金额/元',
        },
        {
          key: 'group_batch_id',
          text: '群组控制批次ID',
        },
      ]
    }
  },
  computed: {
    ...Vuex.mapState({
      statusOpts: state => state.taskBatch.status,
    })
  },
  methods: {
    makeObject (data, propKey, valueKey) {
      let result = {}
      for (const one of data) {
        result[one[valueKey]] = one[propKey]
      }
      return result
    },
    formatStatus (row) {
      const statusOpts = this.makeObject(this.statusOpts, 'label', 'value')
      let result = [statusOpts[row.status]]

      if (row.status * 1 === -2 && row.error_message) {
        result.push(row.error_message)
      }

      return result.join(' ')
    },
    formatProcess (row) {
      if (Number(row.task_type) === 51) {
        return `成功:${row.success_count} 冲突:${row.error_count} 总数:${row.total_count}`
      }
      return `成功:${row.success_count} 失败:${row.error_count} 总数:${row.total_count}`
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/group-batch/group-batch.mixins.js